import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import i18nConfig from "../configs/i18nConfig";
import App from "./app/App";

import { Provider, shallowEqual, useSelector } from "react-redux";
import store from "../redux/store";
import Auth from "../Auth";
import { Spinner } from "react-bootstrap";
import DesktopLogo from "../assets/images/logo/rightdesk-logo-full.svg";

const Loading = () => {
  const states = useSelector(state => state, shallowEqual);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (
      (states["loading.SaveAgentSinceCare"] !== true) &
      (states["loading.getAgentPlatFrom"] !== true) &
      (states["loading.getDatasAgentFromXP"] !== true) &
      (states["loading.getLatestTicket"] !== true) &
      (states["loading.ticketStatsChartPerDate"] !== true) &
      (states["loading.ticketStatsPerDate"] !== true) &
      (states["loading.getAll"] !== true) &
      (states["loading.getDatasTicketSettings"] !== true) &
      (states["loading.getTicketNatureSettings"] !== true) &
      (states["loading.createTicketSubject"] !== true) &
      (states["loading.getTicketSubject"] !== true) &
      (states["loading.createTicketNature"] !== true) &
      (states["loading.createOne"] !== true) &
      (states["loading.reporting"] !== true) &
      (states["loading.ticketInfo"] !== true) &
      (states["loading.ticketReport"] !== true) &
      (states["loading.updateTicket"] !== true)
    ) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
    // console.log(states)
  }, [states]);
  //console.log(states)
  return isLoading ? (
    <div
      style={{
        position: "fixed",
        width: "100vw",
        height: "100vh",
        textAlign: "center",
        top: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffffaa",
        zIndex: 9999
      }}
    >
      <div>
        <div style={{ marginBottom: 30 }}>
          <img src={DesktopLogo} style={{ height: 40 }} alt="logo" />
        </div>
        <div>
          <Spinner animation={"border"} />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
const Root = () => {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18nConfig}>
        <Auth>
          <App />
          <div style={{ position: "relative" }}>
            <Loading />
          </div>
        </Auth>
      </I18nextProvider>
    </Provider>
  );
};

export default Root;
